import gql from 'graphql-tag'
import client from '@stores/apollo'
import handleFetchResult from '@utils/handleFetchResult'

interface IPayload {
  viewer: {
    company: {
      mapping: { bookingImportTemplateFile: string }
    }
  }
}

const mutateHandler = handleFetchResult<IPayload, string>({
  handler: (data) => data.viewer.company.mapping.bookingImportTemplateFile,
  name: 'Booking Import Template',
})

export default function template(): Promise<string> {
  return client.gql.query({ query }).then(mutateHandler)
}

const query = gql`
  query BookingTemplate {
    viewer {
      company {
        mapping {
          bookingImportTemplateFile
        }
      }
    }
  }
`
